import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_menu, {
      "default-active": $setup.activeIndex,
      class: _normalizeClass(['browse-top', { android: $setup.config.android }]),
      mode: "horizontal",
      onSelect: $setup.handleSelect,
      "popper-effect": "light"
    }, {
      default: _withCtx(() => [
        _createCommentVNode("<logo/>"),
        _createVNode(_component_el_menu_item, {
          class: "padding logo-box",
          index: "home"
        }, {
          default: _withCtx(() => [
            _createVNode($setup["logo"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_menu_item, { index: "media-list" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.mediaList')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_menu_item, { index: "manga-list" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.mangaList')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_menu_item, { index: "chapter-list" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.chapterList')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_sub_menu, { index: "browse" }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.browseType), 1 /* TEXT */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "flow" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('browse.flow')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "single" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('browse.single')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "double" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('browse.double')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "half" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('browse.half')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_menu_item, { index: "addBookmark" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.bookmarkTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["default-active", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(['chapter-name', { android: $setup.config.android }])
    }, _toDisplayString($setup.chapterName), 3 /* TEXT, CLASS */)
  ]))
}